module.exports = __webpack_public_path__ + "img/icon1.c28cbbc6.png";